import { Globals, handleAjaxError } from "root/globals";
import { getDataWithPromise } from "root/DataFunctions/BaseDataFns";

export const getActiveGuidanceForSurveyType = (survey_type, onComplete) => {
    const url = Globals.APIFolder + '/guidance/' + survey_type + '/active';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}